// remember this is not the same as NODE_ENV!
export enum Environ {
  // special case for local development only
  LOCAL = "local",

  // special case for JEST unit tests only
  TEST = "test",

  DEV = "dev",
  PROD = "prod",
}
